<template>
    <div>
        <div class="row">
            <div class="col-12 col-sm-6">
                <card-title-component :title="$t('burial.typeOfBurial.title')"></card-title-component>
                <div class="card-content">
                    <b-form-group>
                        <b-form-radio-group id="radios1"
                                            class="o-radio-button-group"
                                            v-model="localTypeOfBurial"
                                            :options="computedData.burialOptions"
                                            name="radioOpenions"
                                            stacked>
                        </b-form-radio-group>
                        <b-form-textarea id="other-burial-input"
                                         class="o-form"
                                         type="text"
                                         v-model="localOtherBurialText"
                                         required
                                         :rows="5"
                                         :max-rows="10"
                                         :placeholder="$t('burial.typeOfBurial.other')"
                                         :disabled="localTypeOfBurial != 'Andere Art'">
                        </b-form-textarea>
                    </b-form-group>
                </div>
            </div>
            <div class="col-12 col-sm-6">
                <card-title-component :title="$t('burial.typeOfGrave.title')"></card-title-component>
                <b-form-group>
                    <b-form-radio-group id="radios2"
                                        class="o-radio-button-group"
                                        v-model="localTypeOfGrave"
                                        :options="computedData.graveOptions"
                                        name="radioOpenion2s"
                                        stacked>
                    </b-form-radio-group>
                    <b-form-textarea id="other-grave-input"
                                     class="o-form"
                                     type="text"
                                     v-model="localOtherGraveText"
                                     required
                                     :rows="5"
                                     :max-rows="10"
                                     :placeholder="$t('burial.typeOfGrave.other')"
                                     :disabled="localTypeOfGrave != 'Andere Art'">
                    </b-form-textarea>
                </b-form-group>
            </div>
        </div>
        <div class="row">
            <div class="col save-button-div">
                <b-btn v-on:click="save" class="o-button"> {{$t('burial.saveButton')}}</b-btn>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters, mapMutations} from 'vuex'
    import {
        BURIAL_ACTION_GET_BURIAL,
        BURIAL_ACTION_SAVE_BURIAL,
        BURIAL_GETTER,
        BURIAL_MUTATION_SINGLE_ENTRY,
        BURIAL_NAMESPACE
    } from '../../store/modules/burial-types'
    import CardTitleComponent from '../ui/card/CardTitleComponent'
    import i18n from '../../assets/i18n/lang'

    export default {
        name: 'Burial',
        metaInfo () { return {title: i18n.t('burial.meta')} },
        components: {'card-title-component': CardTitleComponent},
        computed: {
            computedData: function () {
                return {
                    burialOptions: [
                        {text: i18n.t('burial.typeOfBurial.soilBurial'), value: 'Erdbestattung'},
                        {text: i18n.t('burial.typeOfBurial.cremation'), value: 'Kremation'},
                        {text: i18n.t('burial.typeOfBurial.urn'), value: 'Urne für Zuhause'},
                        {text: i18n.t('burial.typeOfBurial.burialAtLake'), value: 'Seebestattung'},
                        {text: i18n.t('burial.typeOfBurial.burialAtSea'), value: 'Meerbestattung'},
                        {text: i18n.t('burial.typeOfBurial.treeBurial'), value: 'Baumbestattung'},
                        {text: i18n.t('burial.typeOfBurial.rockBurial'), value: 'Felsbestattung'},
                        {text: i18n.t('burial.typeOfBurial.airBurial'), value: 'Luftbestattung'},
                        {text: i18n.t('burial.typeOfBurial.spaceBurial'), value: 'Weltraumbestattung'},
                        {text: i18n.t('burial.typeOfBurial.diamondBurial'), value: 'Diamantbestattung'},
                        {text: i18n.t('burial.typeOfBurial.muslimBurial'), value: 'Muslimische Bestattung'},
                        {
                            text: i18n.t('burial.typeOfBurial.freeWish'),
                            value: 'Frei nach dem Wunsch der Hinterbliebenen'
                        },
                        {text: i18n.t('burial.typeOfBurial.anonymousBurial'), value: 'Anonyme Bestattung'},
                        {text: i18n.t('burial.typeOfBurial.cryopreservation'), value: 'Kryokonservierung'},
                        {text: i18n.t('burial.typeOfBurial.other'), value: 'Andere Art'}
                    ],
                    graveOptions: [
                        {text: i18n.t('burial.typeOfGrave.inlineGrave'), value: 'Reihengrab'},
                        {text: i18n.t('burial.typeOfGrave.rentalTomb'), value: 'Mietgrab'},
                        {text: i18n.t('burial.typeOfGrave.rowNiche'), value: 'Reihennische'},
                        {text: i18n.t('burial.typeOfGrave.rentalNiche'), value: 'Mietnische'},
                        {text: i18n.t('burial.typeOfGrave.communalGrave'), value: 'Beisetzung im Gemeinschaftsgrab'},
                        {text: i18n.t('burial.typeOfGrave.ashInForest'), value: 'Aschenbeisetzung im Wald'},
                        {text: i18n.t('burial.typeOfGrave.urn'), value: 'Urne den Angehörigen übergeben'},
                        {text: i18n.t('burial.typeOfGrave.other'), value: 'Andere Art'}
                    ]
                }
            },
            ...mapGetters(BURIAL_NAMESPACE, {
                burial: BURIAL_GETTER
            }),
            localTypeOfBurial: {
                get () { return this.burial.typeOfBurial },
                set (value) { this.updateBurial({typeOfBurial: value}) }
            },
            localTypeOfGrave: {
                get () { return this.burial.typeOfGrave },
                set (value) { this.updateBurial({typeOfGrave: value}) }
            },
            localOtherBurialText: {
                get () { return this.burial.otherBurialText },
                set (value) { this.updateBurial({otherBurialText: value}) }
            },
            localOtherGraveText: {
                get () { return this.burial.otherGraveText },
                set (value) { this.updateBurial({otherGraveText: value}) }
            }
        },
        methods: {
            ...mapMutations(BURIAL_NAMESPACE, {
                updateBurial: BURIAL_MUTATION_SINGLE_ENTRY
            }),
            ...mapActions(BURIAL_NAMESPACE, {
                loadBurial: BURIAL_ACTION_GET_BURIAL,
                saveBurial: BURIAL_ACTION_SAVE_BURIAL
            }),
            save () { this.saveBurial(this.burial) }
        },
        created () { this.loadBurial() }
    }
</script>

<style lang="scss" scoped>
    .save-button-div {
        text-align: right;
    }

</style>



// WEBPACK FOOTER //
// src/components/funeral/BurialComponent.vue